module.exports = "<loan-page></loan-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/loan.html
// module id = 1879
// module chunks = 0